import React, { Component } from "react";
import { ControlLabel, FormGroup, SelectPicker } from "rsuite";
import axios from "../../utilities/axios";

interface selectProps {
    value: string;
    label: string;
}

interface State {
    data: selectProps[];
    selectedValue: string;
}

export class SelectCustomSelectChangePosition extends Component<any, State> {

    constructor(props: any) {
        super(props);
        this.state = {
            data: [],
            selectedValue: ''
        };
        this.fetchSectors = this.fetchSectors.bind(this);
    }

    componentDidMount() {

        if (this.props.values?.request_change_position_manager_fk_user_id) {
            this.getFirstLoadData();
            this.fetchSectors();
        }
    }

    componentDidUpdate(prevProps: any) {
        if (this.props.values?.request_change_position_manager_fk_user_id !== prevProps.values?.request_change_position_manager_fk_user_id) {
            this.getFirstLoadData();
            this.fetchSectors();
        }
    }

    async getFirstLoadData() {
        const { request_change_position_id } = this.props.values;

        if (request_change_position_id) {
            const response = await axios.get(`/api/v1/request_change_position/get_first_data/${request_change_position_id}`);

            this.setState({
                selectedValue: response.data.value
            });
        }
    }

    fetchSectors() {
        const selectedUserId = Number(this.props.values?.request_change_position_manager_fk_user_id);

        if (selectedUserId) {
            axios.get("/api/v1/request_change_position/get_information", {
                params: {
                    user_id: selectedUserId
                }
            }).then((response: any) => {
                this.setState({ data: response.data });
            }).catch((error: any) => {
                console.error("Error fetching sector information", error);
            });
        }
    }

    handleChange = (value: string) => {
        this.setState({ selectedValue: value });
        this.props.values.request_change_position_sector = value;
    }

    render() {
        return (
            <FormGroup>
                <ControlLabel>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            width: '95%'
                        }}
                    >
                        Departamento Solicitante
                    </div>
                </ControlLabel>
                <div className="rs-form-control-wrapper">
                    <SelectPicker
                        data={this.state.data}
                        labelKey="label"
                        valueKey="value"
                        value={this.state.selectedValue}
                        onChange={this.handleChange}
                        onOpen={this.fetchSectors}
                        placeholder={"Selecione..."}
                        style={{ width: '100%' }}
                    />
                </div>
            </FormGroup>
        );
    }
}
